import { Document, PDFViewer } from '@react-pdf/renderer';
import { Modal } from 'antd';
import React from 'react';
import CreditNotePdf from '../pdf/CreditNotePdf';
import InvoicePdf from '../pdf/InvoicePdf';
import ReceiptPdf from '../pdf/ReceiptPdf';
import ReleaseOrderPdf from '../pdf/ReleaseOrderPdf';
import DebitNoteBillwisePdf from '../pdf/DebitNoteBillwisePdf';
import PaymentVoucher from '../pdf/PaymentVoucher';
import OnAccountPdf from '../pdf/OnAccountPdf';

const PrintPdfModal = (props) => {
    const { visible, close, data, title, pdfType, isClassified } = props;

    const getPdfComponent = (pdfType, element, index) => {
        switch (pdfType) {
            case "releaseOrder":
            case "classifiedReleaseOrder":
                return <ReleaseOrderPdf data={element} key={index} isClassified={isClassified} />

            case "creditNote":
                return <CreditNotePdf data={element} key={index} />

            case "debitNote":
                return <CreditNotePdf data={element} pdfType={pdfType} key={index} />

            case "receipt":
                return <ReceiptPdf data={element} pdfType={pdfType} key={index} />

            case "partyBill":
            case "classifiedPartyBill":
                return <InvoicePdf data={element} pdfType={pdfType} key={index} isClassified={isClassified} />

            case "debitNoteBillwise":
                return <DebitNoteBillwisePdf data={element} pdfType={pdfType} key={index} />

            case "paymentVoucher":
                return <PaymentVoucher data={element} pdfType={pdfType} key={index} />
                
             case "onAccount":
                return <OnAccountPdf data={element} pdfType={pdfType} key={index} />
        }
    }

    return (
        <Modal
            title="Print Preview"
            open={visible}
            width={1000}
            onCancel={close}
            footer={null}
            maskClosable={false}
        >
            <PDFViewer width="950" height="750" >
                <Document title={title}>
                    {data.map((element, index) => {
                        return getPdfComponent(pdfType, element, index)
                    })}
                </Document >
            </PDFViewer>
        </Modal>
    );
}

export default PrintPdfModal;